import { headerJs } from './header';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import sauron from './helpers/observatory';

function runHomepageCode() {
    // console.log('wtf')
    headerJs()
}
const home = document.querySelector('body.home')

home && runHomepageCode()


const brandsSwiperTarget = document.querySelector('.brand-swiper')
brandsSwiperTarget && sauron(brandsSwiperTarget, brandsSwiperTarget.dataset.id, brandsSwiper)

function brandsSwiper() {
    const brandSwiper = new Swiper('.brand-swiper', {
        spaceBetween: 40,
        effect: 'slide',

        loop: true,
        freeMode: true,
        slidesPerView: 4,
        speed: 2000,
        autoplay: {
            delay: 0,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
            waitForTransition: true,
            stopOnLastSlide: false,
        },
        breakpoints: {
            768: {
                loop: false,
                freeMode: false,
                autoplay: false,
                speed: 500,
                slidesPerView: 4,
                spaceBetween: 20
            },
        }

    });



    const prevButton = document.querySelector("#prev-brand");
    const nextButton = document.querySelector("#next-brand");

    prevButton && prevButton.addEventListener("click", () => {
        brandSwiper.slidePrev();
    });

    nextButton && nextButton.addEventListener("click", () => {
        brandSwiper.slideNext();
    });

    brandSwiper.on('slideChange', function () {
        updateNavigationButtons(prevButton, nextButton, brandSwiper);
    });

}


function updateNavigationButtons(prevBtn, nextBtn, swiper) {
    if (swiper.isBeginning) {
        prevBtn.setAttribute("disabled", "true");
    } else {
        prevBtn.removeAttribute("disabled");
    }

    if (swiper.isEnd) {
        nextBtn.setAttribute("disabled", "true");
    } else {
        nextBtn.removeAttribute("disabled");
    }
}


const testimonialSwiperTarget = document.querySelector(".testimonial-swiper")

testimonialSwiperTarget && sauron(testimonialSwiperTarget, testimonialSwiperTarget.dataset.id, testimonialsSwiper)

function testimonialsSwiper() {
    const testimonialSwiper = new Swiper('.testimonial-swiper', {
        spaceBetween: 40,
        slidesPerView: 1,
        autoHeight: false,
        pagination: {
            el: '.swiper-pagination-testimonial',
            type: 'bullets',
        },

    });

    const prevButtonTest = document.querySelector("#prev-testimonial");
    const nextButtonTest = document.querySelector("#next-testimonial");

    prevButtonTest && prevButtonTest.addEventListener("click", () => {
        testimonialSwiper.slidePrev();
    });

    nextButtonTest && nextButtonTest.addEventListener("click", () => {
        testimonialSwiper.slideNext();
    });

    testimonialSwiper.on('slideChange', function () {
        updateNavigationButtons(prevButtonTest, nextButtonTest, testimonialSwiper);
    });

}


const articlesSwiper = new Swiper('.articles-swiper', {
    spaceBetween: 40,
    slidesPerView: 1,
    autoHeight: false,
    pagination: {
        el: '.swiper-pagination-articles',
        type: 'bullets',
    },
    breakpoints: {
        1280: {
            slidesPerView: 3,
        },
    }

});

var heroSwiper = new Swiper(".heroSwiper", {
    autoplay: true,
    delay: 3000,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: { crossFade: true },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },

});


export { testimonialsSwiper, brandsSwiper, articlesSwiper, heroSwiper }